/* eslint-disable quotes */
import _ from 'underscore';

// We use the localized text for display
export const dropdownTextForCreateNewRadioButton = _.memoize(i18n => i18n.getString(_TL_('Import your Google store')));
export const dropdownTextForDraftRadioButton = _.memoize(i18n => i18n.getString(_TL_('Create a draft store')));

// Note that this is not localized. It's a hardcoded text that is in UI's contract with MMC
export const mmcSuggestionTextForNewStores = 'Create a new store';

// Scenarios as defined in Figma.
export const Scenarios = {
  // NOT_DETERMINED is the default value prior to calling GetMappings
  NOT_DETERMINED: 'NOT_DETERMINED',
  NO_MMC_STORES: 'NO_MMC_STORES',
  SINGLE_MMC_STORE_SINGLE_GMC_STORE: 'SINGLE_MMC_STORE_SINGLE_GMC_STORE',
  SINGLE_MMC_STORE_MULTIPLE_GMC_STORES: 'SINGLE_MMC_STORE_MULTIPLE_GMC_STORES',
  MULTIPLE_MMC_STORE_SINGLE_GMC_STORE: 'MULTIPLE_MMC_STORE_SINGLE_GMC_STORE',
  MULTIPLE_MMC_STORE_MULTIPLE_GMC_STORES: 'MULTIPLE_MMC_STORE_MULTIPLE_GMC_STORES',
};


export const draftStoreName = /* istanbul ignore next */
  ({ draftStoreId, i18n, isNewUII18n = true }) =>
    (isNewUII18n ? `${i18n.getString(_TL_('Draft Store - '))}${draftStoreId}` :
      `${i18n.getString('Draft_Store_Prefix')}${draftStoreId}`);

export const googleApiInitializationFailedErrorText = /* istanbul ignore next */
  _.memoize(/* istanbul ignore next */ i18n => i18n.getString(_TL_('We are unable to initialize Google API. ' +
  'Please check the network settings to make Google service accessible. ' +
  'If you are still unable to sign in, please try another browser or contact support.')));

// GMC login error codes. All are tested via demo tests and SI E2E tests
export const idpiframeInitializationFailedErrorText = /* istanbul ignore next */
  _.memoize(/* istanbul ignore next */ i18n => i18n.getString(_TL_('We are unable to sign you into your Google Merchant Center account. ' +
  'Before you try again, adjust your browser settings to clear your cache and allow third party cookies. ' +
  'If you are still unable to sign in, please try another browser or contact support.')));

export const popupBlockedByBrowserErrorText = /* istanbul ignore next */
  _.memoize(/* istanbul ignore next */ i18n => i18n.getString(_TL_('We are unable to sign you into your Google Merchant Center account. ' +
  'Before you try again, adjust your browser settings to allow third party popups. ' +
  'If you are still unable to sign in, please try another browser or contact support.')));

export const popupClosedByUserErrorText = /* istanbul ignore next */
  _.memoize(/* istanbul ignore next */ i18n => i18n.getString(_TL_('We are unable to sign you into your Google Merchant Center account. ' +
  'The popup window was closed without signing in.')));

export const cannotRetrieveRefreshTokenErrorText = /* istanbul ignore next */
  _.memoize(/* istanbul ignore next */ i18n => i18n.getString(_TL_('We are unable to sign you into your Google Merchant Center account, ' +
  `because Microsoft doesn't have offline access to your shopping campaigns. Please sign in again to grant offline access to Microsoft.`)));

export const accessDeniedErrorText = /* istanbul ignore next */
  _.memoize(/* istanbul ignore next */ i18n => i18n.getString(_TL_('We are unable to sign you into your Google Merchant Center account, ' +
  `because Microsoft doesn't have permissions to import your shopping campaigns.`)));

export const authorizationErrorText =/* istanbul ignore next */
  _.memoize(/* istanbul ignore next */ i18n => i18n.getString(_TL_('We were unable to sign you into your Google Merchant Center account. Please try again later.')));

export const clientIdFetchErrorText = /* istanbul ignore next */
  _.memoize(/* istanbul ignore next */ i18n => i18n.getString(_TL_('We were unable to sign you into your Google Merchant Center account. Please try again later.')));

export const gridGenericErrorText = /* istanbul ignore next */
  _.memoize(/* istanbul ignore next */ i18n => i18n.getString(_TL_('No records found.')));

export const alertGenericErrorText = /* istanbul ignore next */
  _.memoize(/* istanbul ignore next */ i18n => i18n.getString(_TL_('Microsoft Ads has encountered an error. Please try again later or contact support.')));

// Occurs when the user has logged into Google Merchant Center,
// but BST is unable to use the refresh token to
// call Google's Content API for Shopping to get the GMC data for the signed-in GetMappings call.
export const googleImportInvalidAuthCodeErrorText = /* istanbul ignore next */
  _.memoize(/* istanbul ignore next */ i18n => i18n.getString(_TL_('Microsoft Ads has encountered an error with your Google Merchant Center account. Please sign out of Google Merchant Center, re-sign in, and try again.')));

export const googleImportContentApiInsufficientAuthScopeErrorText = /* istanbul ignore next */
  _.memoize(/* istanbul ignore next */ i18n => i18n.getString(_TL_("We don't have sufficient permissions to access your Google Merchant Center account. Please try again and contact support if this problem persists.")));

export const signInErrorCodes = {
  GapiInitFailed: 'googleapi_initialization_failed',
  InitFailed: 'idpiframe_initialization_failed',
  PopupBlockedGSI: 'popup_failed_to_open',
  PopupClosedGSI: 'popup_closed',
  AccessDenied: 'access_denied',
  AuthorizationError: 'authorization_error',
};
